<template>
    <div>
        <div class="bar-two" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="barDataTwo.length != 0">
            <div class="per-line flex flex-j-c-sb" v-for="(e, i) in barDataTwo" :key="`${i}one`">
                <div class="flex flex-a-i-center">
                    <img :src="e.avatar_url || require('@/assets/teamAvatar.png')" class="item-avatar"/>
                    <div class="item-box flex flex-a-i-center flex-j-c-sb">
                      <p class="item-name">{{e.true_name || e.nickname}} <span v-if="e.level">({{e.level}})</span></p>
                      <!-- <div style="width:100%" class="flex flex-j-c-sa">
                          <p class="item-tags">报名({{e.enroll_count || 0}}人)</p>
                          <p class="item-tags">贡献值{{e.total_price || 0}}</p>
                      </div> -->
                    </div>
                </div>
                <div class="flex flex-a-i-center">
                    <!-- <p class="item-text">{{e.total||0}}</p> -->
                </div>
            </div>
        </div>
        <DataNull v-if="shownull"/>
        <Nomore v-if="showNoMore"/>
    </div>
</template>

<script>
import {myTeam} from '@/api';
import { MessageBox } from 'mint-ui';
import DataNull from '@/components/DataNull';
import Nomore from '@/components/Nomore';

export default {
  name: 'LevelTwo',
  components: {
    DataNull,
    Nomore
  },
  data(){
    return{
      barDataTwo: [], // 页面数据
      page: 1, // 页数
      loading: true,
      shownull: false,
      showNoMore: false,
      kw: '' // 搜索词
    }
  },
  created() {
    this.kw = this.$route.query.kw || '';
    this.getList();
  },
  watch: {
    $route(a, b) {
      this.loading = true;
      this.page = 1;
      this.shownull = false;
      this.showNoMore = false;
      this.kw = this.$route.query.kw || '';
      this.barDataOne = [];
      this.getList();
    }
  },
  methods: {
    // 加载更多
    loadMore(){
      if (this.loading) return false;
      this.loading = true
      this.page += 1;
      this.getList();
    },
    // 获取列表
    getList() {
      myTeam({level: 2, page:this.page, limit: 20, keyword: this.kw}).then(res => {
        if (res.code === 0) {
          this.barDataTwo = this.barDataTwo.concat(res.data.list);
        } else {
          this.shownull = true;
        }
        if (res.data.list.length === 0) { this.shownull = true; };
        if (res.data.list.length === 20) { this.loading = false; };
        if (res.data.list.length !== 20 && res.data.list.length !== 0) { this.showNoMore = true };
        if (Number(res.data.totalCount) === this.barDataTwo.length) { this.loading = true;this.showNoMore = true; };
      })
    }
  },
};
</script>

<style scoped lang="less">

</style>
